const { encode } = require("@msgpack/msgpack");

const ArgumentType = require('../../extension-support/argument-type');
const BlockType = require('../../extension-support/block-type');
const Cast = require('../../util/cast');
const log = require('../../util/log');
const MathUtil = require('../../util/math-util');
const formatMessage = require('format-message');
const Locales = ['ja', 'ja-Hira', 'en'];
require('regenerator-runtime/runtime');
const AsyncLock = require('async-lock');
const lock = new AsyncLock();

const Message = {
    qrCode : {
        'ja': 'QRコード',
        'ja-Hira': 'QRコード',
        'en': 'QR Code'
    },
    connectMotor: {
        'en':'connect motor',
        'ja':'モーターモジュールを接続',
        'ja-Hira':'モーターモジュールをせつぞく',
    },
    connectController: {
        'en':'connect controller',
        'ja':'コントローラーを接続',
        'ja-Hira':'コントローラーをせつぞく',
    },
    valueJoystickX: {
        'en':'joystick X value',
        'ja':'スティックXの値',
        'ja-Hira':'スティックXのあたい',
    },
    valueJoystickY: {
        'en':'joystick Y value',
        'ja':'スティックYの値',
        'ja-Hira':'スティックYのあたい',
    },
    sliderValue: {
        'en':'slider value',
        'ja':'スライダーの値',
        'ja-Hira':'スライダーのあたい',
    },
    valueButtonA: {
        'en':'button A value',
        'ja':'ボタンAの値',
        'ja-Hira':'ボタンAのあたい',
    },
    valueButtonB: {
        'en':'button B value',
        'ja':'ボタンBの値',
        'ja-Hira':'ボタンBのあたい',
    },
    driverA: {
        'en':'Driver A',
        'ja':'ドライバーA',
        'ja-Hira':'ドライバーA',
    },
    driverB: {
        'en':'Driver B',
        'ja':'ドライバーB',
        'ja-Hira':'ドライバーB',
    },
    driverC: {
        'en':'Driver C',
        'ja':'ドライバーC',
        'ja-Hira':'ドライバーC',
    },
    driverD: {
        'en':'Driver D',
        'ja':'ドライバーD',
        'ja-Hira':'ドライバーD',
    },
    valueButtonAll: {
        'en':'button [BTN] value',
        'ja':'ボタン[BTN]の値',
        'ja-Hira':'ボタン[BTN]のあたい',
    },
    servoDrive2: {
        'en':'Driver[MODULE] Servo[PIN] Angle [ANGLE]',
        'ja':'ドライバー[MODULE] サーボ[PIN]を角度[ANGLE]にする',
        'ja-Hira':'ドライバー[MODULE] サーボ[PIN]をかくど[ANGLE]にする',
    },
    motorDrive2: {
        'en':'Driver[MODULE] Motor[PIN] Speed [SPEED]',
        'ja':'ドライバー[MODULE] モーター[PIN]を速さ[SPEED]にする',
        'ja-Hira':'ドライバー[MODULE] モーター[PIN]をはやさ[SPEED]にする',
    },

    whenButtonPressed: {
        'en':'when [BTN] button pressed',
        'ja':'ボタン [BTN] が押された時',
        'ja-Hira':'ボタン [BTN] がおされたとき',
    },
    whenButtonReleased: {
        'en':'when [BTN] button released',
        'ja':'ボタン [BTN] が放された時',
        'ja-Hira':'ボタン [BTN] がはなされたとき',
    },
    whenJoystickValueChanged: {
        'en':'when joystick [AXIS] changed',
        'ja':'ジョイスティックの [AXIS] が変化した時',
        'ja-Hira':'ジョイスティックの [AXIS] がかわったとき',
    },
    whenSliderValueChanged: {
        'en':'when slider value changed',
        'ja':'スライダーの値が変化した時',
        'ja-Hira':'スライダーのあたいがかわったとき',
    },
    ledControl: {
        'en': 'Driver[MODULE] LED[PIN] Color R[RED] G[GREEN] B[BLUE] Pattern[PATTERN]',
        'ja': 'ドライバー[MODULE] LED[PIN]を 色 R[RED] G[GREEN] B[BLUE] パターン[PATTERN]',
        'ja-Hira': 'ドライバー[MODULE] LED[PIN]を いろ R[RED] G[GREEN] B[BLUE] パターン[PATTERN]',
    },
    ledMatrix: {
        'en': 'Driver[MODULE] LED[PIN] Matrix R[RED] G[GREEN] B[BLUE] [MATRIX]',
        'ja': 'ドライバー[MODULE] LED[PIN]をマトリックス設定 R[RED] G[GREEN] B[BLUE] [MATRIX]',
        'ja-Hira': 'ドライバー[MODULE] LED[PIN]をマトリックスせってい R[RED] G[GREEN] B[BLUE] [MATRIX]',
    },
    ledRandom: {
        'en': 'Driver[MODULE] LED[PIN] with random color Pattern[PATTERN]',
        'ja': 'ドライバー[MODULE] LED[PIN]をランダムな色で パターン[PATTERN]',
        'ja-Hira': 'ドライバー[MODULE] LED[PIN]をランダムないろで パターン[PATTERN]',
    },
}

const RemonoButtons = {
    A: 'A',
    B: 'B',
    X: 'X',
    Y: 'Y',
    J: 'J',
};

const RemonoJoystick = {
    X: 'X',
    Y: 'Y',
    ANY: 'ANY',
};

const STUDEO_SERVO_PINS = {
    1: '1',
    2: '2',
    3: '3',
    4: '4',
};

const STUDEO_LED_PINS = {
    1: '1',
    2: '2',
};

const STUDEO_MOTOR_PINS = {
    1: '1',
    2: '2',
};

const STUDEO_MOTOR_MODULES = {
    A: 'A',
    B: 'B',
    C: 'C',
    D: 'D',
};

const blockIconURI = 'data:image/png;base64,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';

class MotorDriver {
    constructor(name) {
        this.name = name;
        this.motor1value = 0;
        this.motor2value = 0;
        this.servo1value = -1;
        this.servo2value = -1;
        this.servo3value = -1;
        this.servo4value = -1;
        this.sendValue =  [0, 0, -1, -1, -1, -1]; 
        this.needToSend = false;
        this.needToSendLed1 = false;
        this.needToSendLed2 = false;
        this.packetLed1 =  []; 
        this.packetLed2 =  []; 
        // キャッシュ用プロパティ
        this.motorCharacteristic = null;
        this.led1Characteristic = null;
        this.led2Characteristic = null;
    }
}

class Scratch3NewBlocks {

    constructor(runtime) {
        this.runtime = runtime;
        this.locale = this._getViewerLanguageCode();
        window.viviwareclass = this;
        this.buttonA = false;
        this.buttonB = false;
        this.buttonX = false;
        this.buttonY = false;
        this.buttonJ = false;
        this.sliderValue = 0;
        this.sliderValue_before = 0;
        this.runtime = runtime;
        // 「BLEから届いた最新値」をとりあえず格納するための変数
        this._joystickXNew = 0;
        this._joystickYNew = 0;
        this._joystickXChanged = false;
        this._joystickYChanged = false;
    
        // 実際にScratchから参照される値
        this.joystickX = 0;
        this.joystickY = 0;
        this.joystickX_before = 0;
        this.joystickY_before = 0;
    
        this.joystickChangedFlag = false;  // 変化を検知するためのフラグ
        this.updateFlag = false;  // 更新検知フラグ

        // TODO 暫定対応
        this.joystickLastUpdateTime = Date.now(); // 最後に値が更新された時間を記録
        this.joystickUpdateInterval = 100; // ミリ秒単位での強制チェック間隔
        this.beforeWhenJoystickValueChanged = false;
        this.beforeWhenSliderValueChanged = false;

        this.buttonA_pressed_before = false;
        this.buttonB_pressed_before = false;
        this.buttonX_pressed_before = false;
        this.buttonY_pressed_before = false;
        this.buttonJ_pressed_before = false;

        this.buttonA_released_before = true;
        this.buttonB_released_before = true;
        this.buttonX_released_before = true;
        this.buttonY_released_before = true;
        this.buttonJ_released_before = true;

        this.device = null;
        this.controllerVersion = 1;
        this.driverVersion = 1;
        this.connectedDevices = [];
        // this.connectedDeviceservers = [];
        // this.connectedMotorDriver = [];
        
        this.server = null;
        this.serviceUuid = "6c6d1392-9637-3b48-53a8-962853bff36b";
        this.characteristicUuid = "c3af7ad9-13e5-2d18-48c8-52bc11e99c03";

        this.handleCharacteristicValueChanged = this.handleCharacteristicValueChanged.bind(this);
        this.whenPt2ButtonPressed = this.whenPt2ButtonPressed.bind(this);
        this.whenPt2ButtonReleased = this.whenPt2ButtonReleased.bind(this);

        // 定期実行
        setInterval(() => this.sendDataBle(), 60); // 秒間15回の頻度でsendDataを実行
        setInterval(() => this._updateValues(), 30);
    }

    get BUTTONS_MENU() {
        return [
            {
                text: 'A',
                value: RemonoButtons.A
            },
            {
                text: 'B',
                value: RemonoButtons.B
            },
            {
                text: 'X',
                value: RemonoButtons.X
            },
            {
                text: 'Y',
                value: RemonoButtons.Y
            },
            {
                text: 'J',
                value: RemonoButtons.J
            },
        ];
    }

    get JOYSTICK_MENU() {
        return [
            {
                text: 'X',
                value: RemonoJoystick.X
            },
            {
                text: 'Y',
                value: RemonoJoystick.Y
            },
            {
                text: 'ANY',
                value: RemonoJoystick.ANY
            }
        ];
    }

    get SERVO_PINS() {
        return [
            {
                text: '1',
                value: STUDEO_SERVO_PINS[1]
            },
            {
                text: '2',
                value: STUDEO_SERVO_PINS[2]
            },
            {
                text: '3',
                value: STUDEO_SERVO_PINS[3]
            },
            {
                text: '4',
                value: STUDEO_SERVO_PINS[4]
            },
        ];
    }
    
    get MOTOR_PINS() {
        return [
            {
                text: '1',
                value: STUDEO_MOTOR_PINS[1]
            },
            {
                text: '2',
                value: STUDEO_MOTOR_PINS[2]
            },
        ];
    }

    get LED_PINS() {
        return [
            {
                text: '1',
                value: STUDEO_LED_PINS[1]
            },
            {
                text: '2',
                value: STUDEO_LED_PINS[2]
            }
        ];
    }

    get MOTOR_MODULES() {
        return [
            {
                text: 'A',
                value: STUDEO_MOTOR_MODULES.A
            },
            {
                text: 'B',
                value: STUDEO_MOTOR_MODULES.B
            },
            {
                text: 'C',
                value: STUDEO_MOTOR_MODULES.C
            },
            {
                text: 'D',
                value: STUDEO_MOTOR_MODULES.D
            },
        ];
    }

    getInfo() {

        this.locale = this._getViewerLanguageCode();
        // ロケールが有効な値であることを確認
        if (!Message.connectMotor[this.locale]) {
            console.error(`Invalid locale: ${this.locale}`);
            this.locale = 'en'; // デフォルトロケールにフォールバック
        }
        return {
            id: 'remono2',
            name: 'remono2',
            color1: '#0E6EB8',  // 主色
            color2: '#00008b',  // 二次色
            color3: '#191970',  // 三次色
            blockIconURI: blockIconURI,
            blocks: [
                {
                    opcode: 'connect_mtr',
                    blockType: BlockType.COMMAND,
                    text: Message.connectMotor[this.locale],
                    arguments: {
                        ANGLE: {
                            type: ArgumentType.NUMBER,
                            defaultValue: 0
                        }
                    }
                },
                {
                    opcode: 'connect_con',
                    blockType: BlockType.COMMAND,
                    text: Message.connectController[this.locale],
                    arguments: {
                        ANGLE: {
                            type: ArgumentType.NUMBER,
                            defaultValue: 0
                        }
                    }
                },
                {
                    opcode: 'motorDrive2',
                    blockType: BlockType.COMMAND,
                    text: Message.motorDrive2[this.locale],
                    arguments: {
                        MODULE: {
                            type: ArgumentType.STRING,
                            menu: 'motor_modules',
                            defaultValue: STUDEO_MOTOR_MODULES.A
                        },
                        PIN: {
                            type: ArgumentType.STRING,
                            menu: 'motor_pins',
                            defaultValue: STUDEO_MOTOR_PINS[1]
                        },
                        SPEED: {
                            type: ArgumentType.NUMBER,
                            defaultValue: 0
                        }
                    }
                },
                {
                    opcode: 'servoDrive2',
                    blockType: BlockType.COMMAND,
                    text: Message.servoDrive2[this.locale],
                    arguments: {
                        MODULE: {
                            type: ArgumentType.STRING,
                            menu: 'motor_modules',
                            defaultValue: STUDEO_MOTOR_MODULES.A
                        },
                        PIN: {
                            type: ArgumentType.STRING,
                            menu: 'servo_pins',
                            defaultValue: STUDEO_SERVO_PINS[1]
                        },
                        ANGLE: {
                            type: ArgumentType.NUMBER,
                            defaultValue: 0
                        }
                    }
                },
                {
                    opcode: 'ledControl',
                    blockType: BlockType.COMMAND,
                    text: Message.ledControl[this.locale],
                    arguments: {
                        MODULE: {
                            type: ArgumentType.STRING,
                            menu: 'motor_modules',
                            defaultValue: STUDEO_MOTOR_MODULES.A
                        },
                        PIN: {
                            type: ArgumentType.STRING,
                            menu: 'led_pins',
                            defaultValue: STUDEO_LED_PINS[1]
                        },
                        RED: {
                            type: ArgumentType.NUMBER,
                            defaultValue: 0
                        },
                        GREEN: {
                            type: ArgumentType.NUMBER,
                            defaultValue: 0
                        },
                        BLUE: {
                            type: ArgumentType.NUMBER,
                            defaultValue: 100
                        },
                        PATTERN: {
                            type: ArgumentType.STRING,
                            defaultValue: '1010101010101010101010101'
                        }
                    }
                },

                {
                    opcode: 'ledMatrix',
                    blockType: BlockType.COMMAND,
                    text: Message.ledMatrix[this.locale],
                    arguments: {
                        MODULE: {
                            type: ArgumentType.STRING,
                            menu: 'motor_modules',
                            defaultValue: STUDEO_MOTOR_MODULES.A
                        },
                        PIN: {
                            type: ArgumentType.STRING,
                            menu: 'led_pins',
                            defaultValue: STUDEO_LED_PINS[1]
                        },
                        RED: {
                            type: ArgumentType.NUMBER,
                            defaultValue: 0
                        },
                        GREEN: {
                            type: ArgumentType.NUMBER,
                            defaultValue: 0
                        },
                        BLUE: {
                            type: ArgumentType.NUMBER,
                            defaultValue: 255
                        },
                        MATRIX: {
                            type: ArgumentType.MATRIX,
                            defaultValue: '0000000000000000000000000' // 初期値はすべて消灯
                        }
                    }
                },   
                {
                    opcode: 'ledRandom',
                    blockType: BlockType.COMMAND,
                    text: Message.ledRandom[this.locale],
                    arguments: {
                        MODULE: {
                            type: ArgumentType.STRING,
                            menu: 'motor_modules',
                            defaultValue: STUDEO_MOTOR_MODULES.A
                        },
                        PIN: {
                            type: ArgumentType.STRING,
                            menu: 'led_pins',
                            defaultValue: STUDEO_LED_PINS[1]
                        },
                        PATTERN: {
                            type: ArgumentType.STRING,
                            defaultValue: '1010101010101010101010101'
                        }
                    }
                },

           
                {
                    opcode: 'whenPt2ButtonPressed',
                    blockType: BlockType.HAT,
                    text: Message.whenButtonPressed[this.locale],
                    arguments: {
                        BTN: {
                            type: ArgumentType.STRING,
                            menu: 'buttons',
                            defaultValue: RemonoButtons.A
                        }
                    }
                },
                {
                    opcode: 'whenPt2ButtonReleased',
                    blockType: BlockType.HAT,
                    text: Message.whenButtonReleased[this.locale],
                    arguments: {
                        BTN: {
                            type: ArgumentType.STRING,
                            menu: 'buttons',
                            defaultValue: RemonoButtons.A
                        }
                    }
                },
                {
                    opcode: 'whenJoystickValueChanged',
                    blockType: BlockType.HAT,
                    text: Message.whenJoystickValueChanged[this.locale],
                    arguments: {
                        AXIS: {
                            type: ArgumentType.STRING,
                            menu: 'joystick',
                            defaultValue: this.JOYSTICK_MENU.ANY
                        }
                    }
                },
                {
                    opcode: 'whenSliderValueChanged',
                    blockType: BlockType.HAT,
                    text: Message.whenSliderValueChanged[this.locale],
                },
                {
                    opcode: 'getRemonoButton',
                    blockType: BlockType.BOOLEAN,
                    text: Message.valueButtonAll[this.locale],
                    arguments: {
                        BTN: {
                            type: ArgumentType.STRING,
                            menu: 'buttons',
                            defaultValue: RemonoButtons.A
                        }
                    }
                },
                {
                    opcode: 'getJoystickX',
                    blockType: BlockType.REPORTER,
                    text: Message.valueJoystickX[this.locale],
                },
                {
                    opcode: 'getJoystickY',
                    blockType: BlockType.REPORTER,
                    text: Message.valueJoystickY[this.locale],
                },
                {
                    opcode: 'getSliderValue',
                    blockType: BlockType.REPORTER,
                    text: Message.sliderValue[this.locale],
                },
                {
                    opcode: 'getDriverA',
                    blockType:  BlockType.REPORTER,
                    text: Message.driverA[this.locale],
                },
                {
                    opcode: 'getDriverB',
                    blockType:  BlockType.REPORTER,
                    text: Message.driverB[this.locale],
                },
                {
                    opcode: 'getDriverC',
                    blockType:  BlockType.REPORTER,
                    text: Message.driverC[this.locale],
                },
                {
                    opcode: 'getDriverD',
                    blockType:  BlockType.REPORTER,
                    text: Message.driverD[this.locale],
                },
                {
                    opcode: 'writeProgram',
                    blockType: BlockType.COMMAND,
                    text: 'Write Logic to remono',
                },
            ],
            menus: {
                motor_modules: {
                    acceptReporters: true,
                    items: this.MOTOR_MODULES
                },
                motor_pins: {
                    acceptReporters: true,
                    items: this.MOTOR_PINS
                },
                servo_pins: {
                    acceptReporters: true,
                    items: this.SERVO_PINS
                },
                led_pins: {
                    acceptReporters: true,
                    items: this.LED_PINS
                },
                buttons: {
                    acceptReporters: true,
                    items: this.BUTTONS_MENU
                },
                joystick: {
                    acceptReporters: true,
                    items: this.JOYSTICK_MENU
                },
            }
        };
    }

    _getViewerLanguageCode () {
        const locale = formatMessage.setup().locale;
        if (Locales.includes(locale)) {
            return locale;
        }
        return 'en';
    }

    writeLog(args) {
        const text = Cast.toString(args.TEXT);
        log.log(text);
        console.log(module);
    }
    setButton() {
        console.log("setButton");
        mytext = "hello";
    }

    getRemonoButton (args) {
        if (args.BTN === 'A') {
            return this.buttonA;
        } else if (args.BTN === 'B') {
            return this.buttonB;
        } else if (args.BTN === 'X') {
            return this.buttonX;
        } else if (args.BTN === 'Y') {
            return this.buttonY;
        } else if (args.BTN === 'J') {
            return this.buttonJ;
        } else {
            return false;
        }
    }


    async connect_mtr(args) {
        console.log("connect_mtr");
        let tmpDevice;
        let options = {
            filters: [
                { namePrefix: "remono_drv_"}
            ],
            optionalServices: ["6c6d1392-9637-3b48-53a8-962853bff36b"]
        };
        try {
            const device = await navigator.bluetooth.requestDevice(options);
            console.log(`connected: ${device.name}`);
            tmpDevice = device;
    
            // 空いているスロットを探す
            let availableSlot = this.connectedDevices.findIndex(device => device === null);
            if (availableSlot === -1) {
                // 空いているスロットがなければ、新しいスロットを追加
                availableSlot = this.connectedDevices.length;
                if (availableSlot >= 4) {
                    alert('すいません、これ以上接続できないです');
                    return;
                }
            }
    
            // デバイス情報を保存
            this.connectedDevices[availableSlot] = {
                id: device.id,
                name: device.name,
                driver: new MotorDriver(device.name),
                server: null,
            };
    
            // 接続解除時のイベントリスナー設定
            const disconnectHandler = (event) => {
                console.log('モーターモジュールが切断されました！');
                alert('モーターモジュールが切断されました！');
                this.removeDevice(event.target.id);
                // イベントリスナーを削除
                device.removeEventListener('gattserverdisconnected', disconnectHandler);
            };
            // イベントリスナーを登録
            device.addEventListener('gattserverdisconnected', disconnectHandler);

            this.updateDeviceDisplay();

            // GATT サーバーに接続
            const server = await device.gatt.connect();
            console.log('GATTサーバーに接続しました');

            // 統合配列にサーバー情報を追加
            const deviceIndex = this.connectedDevices.findIndex(device => device && device.id === tmpDevice.id);

            // サービスを取得
            const service = await server.getPrimaryService(this.serviceUuid);

            // 特性を取得
            const [
                motorCharacteristic,
                led1Characteristic,
                led2Characteristic,
                readCharacteristic
            ] = await Promise.all([
                service.getCharacteristic(this.characteristicUuid),
                service.getCharacteristic('a5a2401b-ab27-e130-b0f5-bcac22c3880d'),
                service.getCharacteristic('a5a2401b-ab27-e130-b0f5-bcac22c3880e'),
                service.getCharacteristic('92a2401b-ab27-e130-b0f5-bcac22c3888a')
            ]);

            // デバイス情報を更新
            const deviceInfo = this.connectedDevices[availableSlot];
            deviceInfo.server = server;
            deviceInfo.driver.motorCharacteristic = motorCharacteristic;
            deviceInfo.driver.led1Characteristic = led1Characteristic;
            deviceInfo.driver.led2Characteristic = led2Characteristic;

            // ドライバーの初期化
            const driver = deviceInfo.driver;
            driver.needToSend = false;
            driver.needToSendLed1 = false;
            driver.needToSendLed2 = false;
            driver.sendValue = [0, 0, -1, -1, -1, -1];
            driver.packetLed1 = [];
            driver.packetLed2 = [];

            // バージョン情報の読み取り
            const value = await readCharacteristic.readValue();
            this.handleReadValueChangedMotor(value);

            this.updateDeviceDisplay();            
        } catch (error) {
            console.error(`接続中にエラーが発生しました: ${error}`);
            alert(`接続中にエラーが発生しました: ${error.message}`);
        }
    }
    
    removeDevice(deviceId) {
        const deviceIndex = this.connectedDevices.findIndex(device => device && device.id === deviceId);
        if (deviceIndex !== -1) {
            // driver オブジェクトの状態をリセット
            const driver = this.connectedDevices[deviceIndex].driver;
            if (driver) {
                driver.needToSend = false;
                driver.needToSendLed1 = false;
                driver.needToSendLed2 = false;
                driver.sendValue = [0, 0, -1, -1, -1, -1];
                driver.packetLed1 = [];
                driver.packetLed2 = [];
            }
            this.connectedDevices[deviceIndex] = null; // スロットを null に設定
            this.updateDeviceDisplay();
            console.log(`Device with ID ${deviceId} removed`);
        }
    }
    
    updateDeviceDisplay() {
        // let displayText = this.connectedDevices.map((device, index) => `Device ${index + 1}: ${device.name} (${device.id})`).join('\n');
        // // ここでScratch UIコンポーネントにdisplayTextを表示する処理を追加
        // console.log(displayText);
    }
    
    // 再接続の試行回数を管理するオブジェクト
    reconnectionAttemptsCon = {};

    async connect_con(args) {
        console.log("connect_con");

        let options = {
            filters: [
                { namePrefix: "remono_con_" }
            ],
            optionalServices: ["6c6d1392-9637-3b48-53a8-962853bff36b"]
        };

        try {
            const device = await navigator.bluetooth.requestDevice(options)
            console.log(`connected: ${device.name}`);
            this.device = device;
            // 再接続の試行回数を初期化
            this.reconnectionAttemptsCon[device.id] = 0;
            const server = await this.device.gatt.connect();
            const service = await server.getPrimaryService(this.serviceUuid);
            const characteristic1 = await service.getCharacteristic('265d940f-c36a-e742-2f80-f9a9893f2aea');
            const characteristic2 = await service.getCharacteristic('92a2401b-ab27-e130-b0f5-bcac22c3888a');

            // characteristic1の設定
            await characteristic1.startNotifications();
            characteristic1.addEventListener('characteristicvaluechanged', this.handleCharacteristicValueChanged);
            console.log('Notifications for characteristic1 have been started.');

            // characteristic2のプロパティ確認と処理
            console.log('Characteristic2 properties:', characteristic2.properties);
            if (characteristic2.properties.read) {
                const value = await characteristic2.readValue();
                this.handleReadValueChanged(value);
            } else if (characteristic2.properties.notify) {
                await characteristic2.startNotifications();
                characteristic2.addEventListener('characteristicvaluechanged', this.handleReadValueChanged);
                console.log('Notifications for characteristic2 have been started.');
            } else {
                console.error('Characteristic2 does not support read or notify.');
            }

            // 既存のイベントリスナーを削除（必要に応じて）
            if (this.device) {
                this.device.removeEventListener('gattserverdisconnected', this.handleDisconnect_C);
            }

            // イベントリスナーを設定
            this.handleDisconnect_C = event => {
                console.log('コントローラーが切断されました！');
            
                // 再接続の試行回数を確認
                if (this.reconnectionAttemptsCon[event.target.id] < 1) {
                    this.reconnectionAttemptsCon[event.target.id]++;
                    console.log('再接続を試みます...');
            
                    // 少し待ってから再接続を試みる
                    setTimeout(() => {
                        this.reconnectController(event.target)
                            .then(() => {
                                // 再接続に成功した場合の処理（必要に応じて）
                                console.log('再接続に成功しました。');
                            })
                            .catch(error => {
                                console.error('再接続に失敗しました:', error);
                                // 再接続に失敗した場合のみアラートを表示
                                alert('コントローラーが切断されました！');
                            });
                    }, 300); // 1秒待機
                } else {
                    // 再接続の試行回数を超えた場合もアラートを表示
                    alert('コントローラーが切断されました！');
                }
            };
            this.device.addEventListener('gattserverdisconnected', this.handleDisconnect_C);
        } catch(error) {
            console.error(`何かがうまくいきませんでした ${error}`);
        } 
    }

    // タイムアウト付きの再接続処理
    async reconnectController(device) {
        try {
            // 2秒間のタイムアウトを設定して再接続を試みる
            const server = await this.withTimeout(device.gatt.connect(), 2000, "再接続がタイムアウトしました");

            console.log('コントローラーの再接続に成功しました');
            this.reconnectionAttemptsCon[device.id] = 0; // 再接続成功時に試行回数をリセット

            const service = await server.getPrimaryService(this.serviceUuid);
            const [characteristic1, characteristic2] = await Promise.all([
                service.getCharacteristic('265d940f-c36a-e742-2f80-f9a9893f2aea'),
                service.getCharacteristic('92a2401b-ab27-e130-b0f5-bcac22c3888a')
            ]);

            await characteristic1.startNotifications();
            characteristic1.addEventListener('characteristicvaluechanged', this.handleCharacteristicValueChanged);
            console.log('Notifications have been restarted.');

            const value = await characteristic2.readValue();
            this.handleReadValueChanged(value);
        } catch (error) {
            console.error('再接続に失敗しました:', error);
            throw error;
        }
    }

    // タイムアウトを指定したPromiseラッパー関数
    withTimeout(promise, timeoutMs, errorMessage) {
        return new Promise((resolve, reject) => {
            const timeoutId = setTimeout(() => {
                reject(new Error(errorMessage));
            }, timeoutMs);

            promise
                .then((result) => {
                    clearTimeout(timeoutId);
                    resolve(result);
                })
                .catch((error) => {
                    clearTimeout(timeoutId);
                    reject(error);
                });
        });
    }
    
    // 新しく追加する関数、readした値を処理します
    handleReadValueChanged(value) {
        // DataViewオブジェクトとして値が渡されるので、それを適切に処理
        const decodedValue = new TextDecoder().decode(value);
        console.log('Read value from characteristic 2:', decodedValue);
        this.controllerVersion = isNaN(parseInt(decodedValue, 10)) ? 1 : parseInt(decodedValue, 10);
        console.log('controller version number is ' + this.controllerVersion);
    }
    handleReadValueChangedMotor(value) {
        // DataViewオブジェクトとして値が渡されるので、それを適切に処理
        const decodedValue = new TextDecoder().decode(value);
        console.log('Read value from characteristic 2:', decodedValue);
        this.driverVersion = isNaN(parseInt(decodedValue, 10)) ? 1 : parseInt(decodedValue, 10);
        console.log('driver version number is ' + this.driverVersion);
    }

    // （controller）統合された characteristic の値が変更されたときに呼び出される関数
    handleCharacteristicValueChanged(event) {
        const rawData = event.target.value;
    
        // controllerVersion に応じて処理を切り替える
        if (this.controllerVersion === 1) {
            // 従来の処理
            const values = Scratch3NewBlocks.parseCommaSeparatedNumbers(rawData);
            // console.log('Received values:', values, " version: ", this.controllerVersion);
    
            // バイト数に応じて適切に処理を行う
            if (values.length >= 3) {
                // 最低4バイトが存在すればjoystickのデータがある
                this.joystickX_before = this.joystickX;
                this.joystickY_before = this.joystickY;
                this.joystickX = parseInt(values[0], 10);
                this.joystickY = parseInt(values[1], 10);
                const pushed = parseInt(values[2], 10);
                this.setButtonJ(pushed);
                
                console.log(`JoystickX: ${this.joystickX}, JoystickY: ${this.joystickY}, Pushed: ${pushed}`);
            }
    
            if (values.length >= 8) {
                // 9バイト以上であれば、ボタンとスライダーのデータもある
                const buttonA = parseInt(values[3], 10);
                const buttonB = parseInt(values[4], 10);
                const buttonX = parseInt(values[5], 10);
                const buttonY = parseInt(values[6], 10);
                this.sliderValue_before = this.sliderValue;
                this.sliderValue = parseInt(values[7], 10);
    
                console.log(`ButtonA: ${buttonA}, ButtonB: ${buttonB}, ButtonX: ${buttonX}, ButtonY: ${buttonY}, SliderValue: ${this.sliderValue}`);
    
                // ボタンの状態を設定
                this.setButtonA(buttonA);
                this.setButtonB(buttonB);
                this.setButtonX(buttonX);
                this.setButtonY(buttonY);
            }
    
            // データが不足している場合でもエラーが発生しないようにする
            if (values.length < 4) {
                console.warn('Received data length is shorter than expected for joystick control.');
            }
            if (values.length < 9) {
                console.warn('Received data length is shorter than expected for button controls.');
            }
        } else if (this.controllerVersion >= 2) {
            // 新しい処理
            const byteArray = new Uint8Array(rawData.buffer);
            console.log('Received raw byte array:', byteArray, " version: ", this.controllerVersion);


            if (byteArray.length < 5) {
                console.warn('Received data is too short for version 2+ controller.');
                return;
            }
    
            // 1バイト目は無視
            // 2バイト目、3バイト目はジョイスティックの値を符号付きに変換
            this.sliderValue_before = this.sliderValue;
            this._joystickXNew = byteArray[1] > 127 ? byteArray[1] - 256 : byteArray[1];
            this._joystickYNew = byteArray[2] > 127 ? byteArray[2] - 256 : byteArray[2];
            console.log('Received joystickY : ' + this.joystickY + ', joystickY_before: ' + this.joystickY_before);

            // 4バイト目をビット配列としてボタンに格納
            const buttonBits = byteArray[3];
            this.setButtonJ((buttonBits & 0b10000) !== 0); // 5番目のビット (16)
            this.setButtonA((buttonBits & 0b01000) !== 0); // 4番目のビット (8)
            this.setButtonB((buttonBits & 0b00100) !== 0); // 3番目のビット (4)
            this.setButtonX((buttonBits & 0b00010) !== 0); // 2番目のビット (2)
            this.setButtonY((buttonBits & 0b00001) !== 0); // 1番目のビット (1)
    
            // 5バイト目をsliderValueに格納
            this.sliderValue = byteArray[4];
    
            // console.log(`JoystickX: ${this.joystickX}, JoystickY: ${this.joystickY}, ButtonY: ${this.buttonY}, ButtonX: ${this.buttonX}, ButtonB: ${this.buttonB}, ButtonA: ${this.buttonA}, Pushed: ${this.buttonJ}, SliderValue: ${this.sliderValue}`);
        }
        this.joystickLastUpdateTime  = Date.now();
    }
        
    // setIntervalで呼ばれるフレーム処理
    _updateValues() {
        console.log('update JoystickX_before:', this.joystickX_before,' JoystickX:', this.joystickX, ' JoystickXNew:', this._joystickXNew);
        // 1フレーム内だけ「前回値」と比較する
        this.joystickX_before = this.joystickX;
        this.joystickY_before = this.joystickY;

        // 変更があればフラグを立てる
        this._joystickXChanged = (this._joystickXNew !== this.joystickX);
        this._joystickYChanged = (this._joystickYNew !== this.joystickY);

        // 実際に今フレームの値を更新
        this.joystickX = this._joystickXNew;
        this.joystickY = this._joystickYNew;
    }
    
    motorDrive2(args) {
        console.log("setMotorDrive ready");
        lock.acquire('key', (done) => {
            console.log("setMotorDrive start");
            const module = args.MODULE;
            let tmpMotorDriver;
            switch(module) {
                case 'A':
                    tmpMotorDriver = this.connectedDevices[0]?.driver;
                    break;
                case 'B':
                    tmpMotorDriver = this.connectedDevices[1]?.driver;
                    break;
                case 'C':
                    tmpMotorDriver = this.connectedDevices[2]?.driver;
                    break;
                case 'D':
                    tmpMotorDriver = this.connectedDevices[3]?.driver;
                    break;
            }
            if (!tmpMotorDriver) {
                console.error(`Driver for module ${module} not found`);
                done();
                return;
            }

            // デバイスが接続されているか確認
            const deviceIndex = this.connectedDevices.findIndex(device => device && device.driver === tmpMotorDriver);
            if (deviceIndex === -1 || !this.connectedDevices[deviceIndex].server) {
                console.error(`Device for module ${module} is not connected`);
                done();
                return;
            }
    
            // console.log(`driver : ${tmpMotorDriver.name}`);

            const pin = args.PIN;
            let speed = args.SPEED;
            speed = Math.max(-100, Math.min(100, speed));
            console.log(`motor drive ${module} ${pin}, speed ${speed}`);

            switch (pin) {
                case "1": 
                    tmpMotorDriver.motor1value = speed; 
                    tmpMotorDriver.sendValue[0] = speed;
                    break;
                case "2": 
                    tmpMotorDriver.motor2value = speed;
                    tmpMotorDriver.sendValue[1] = speed;
                    break;
            }
            console.log("needToSend flag true");
            tmpMotorDriver.needToSend = true; // 送信フラグを立てる
            done();
        });    
    }

    
    servoDrive2(args) {
        lock.acquire('key', (done) => {
            const module = args.MODULE;
            const pin = args.PIN;
            let angle = Cast.toNumber(args.ANGLE); // Cast to number just to be sure
    
            // this.driverVersion に応じて角度範囲を制限
            if (this.driverVersion >= 300) {
                // 0-100 の範囲で制限
                angle = Math.max(0, Math.min(100, angle));
            } else {
                // 0-180 の範囲で制限
                angle = Math.max(0, Math.min(180, angle));
            }
    
            let tmpMotorDriver;
            switch(module) {
                case 'A':
                    tmpMotorDriver = this.connectedDevices[0].driver;
                    break;
                case 'B':
                    tmpMotorDriver = this.connectedDevices[1].driver;
                    break;
                case 'C':
                    tmpMotorDriver = this.connectedDevices[2].driver;
                    break;
                case 'D':
                    tmpMotorDriver = this.connectedDevices[3].driver;
                    break;
            }
    
            switch (pin) {
                case "1":
                    tmpMotorDriver.servo1value = angle;
                    tmpMotorDriver.sendValue[2] = angle;
                    break;
                case "2": 
                    tmpMotorDriver.servo2value = angle;
                    tmpMotorDriver.sendValue[3] = angle;
                    break;
                case "3": 
                    tmpMotorDriver.servo3value = angle;
                    tmpMotorDriver.sendValue[4] = angle;
                    break;
                case "4": 
                    tmpMotorDriver.servo4value = angle;
                    tmpMotorDriver.sendValue[5] = angle;
                    break;
            }
    
            tmpMotorDriver.needToSend = true;
            done();
        });
    }
    
    ledControl(args) {
        lock.acquire('key', (done) => {
            const module = args.MODULE;
            const pin = args.PIN;
            let red = Cast.toNumber(args.RED);
            let green = Cast.toNumber(args.GREEN);
            let blue = Cast.toNumber(args.BLUE);
            let pattern = args.PATTERN;
            let tmpMotorDriver;
    
            // バージョンが300以上の場合、red, green, blueを0-100の範囲に制限
            if (this.driverVersion >= 300) {
                red = Math.max(0, Math.min(100, red));  // 0-100の範囲に収める
                green = Math.max(0, Math.min(100, green));  // 0-100の範囲に収める
                blue = Math.max(0, Math.min(100, blue));  // 0-100の範囲に収める
            } else {
                // バージョンが300未満の場合、0-255の範囲に収める
                red = Math.max(0, Math.min(255, red));  // 0-255の範囲に収める
                green = Math.max(0, Math.min(255, green));  // 0-255の範囲に収める
                blue = Math.max(0, Math.min(255, blue));  // 0-255の範囲に収める
            }

            // パターンを32ビット（4バイト）に制限
            pattern = pattern.slice(0, 32); // 最大32文字（32ビット）に切り詰める

            // パターンをビット単位でバイト配列に変換し、4バイトに制限
            let patternBytes = [0x00, 0x00, 0x00, 0x00];
            for (let i = 0; i < pattern.length; i++) {
                const byteIndex = Math.floor(i / 8);
                const bitIndex = i % 8;
                if (pattern[i] === '1') {
                    patternBytes[byteIndex] |= (1 << bitIndex);
                }
            }
    
            switch (module) {
                case 'A':
                    tmpMotorDriver = this.connectedDevices[0].driver;
                    break;
                case 'B':
                    tmpMotorDriver = this.connectedDevices[1].driver;
                    break;
                case 'C':
                    tmpMotorDriver = this.connectedDevices[2].driver;
                    break;
                case 'D':
                    tmpMotorDriver = this.connectedDevices[3].driver;
                    break;
            }
    
            switch (pin) {
                case "1":
                    tmpMotorDriver.needToSendLed1 = true;
                    // RGBとパターンを組み合わせたパケットを作成
                    if (this.driverVersion >= 300) {
                        tmpMotorDriver.packetLed1 = [red, green, blue, ...patternBytes, 0];
                    } else {
                        tmpMotorDriver.packetLed1 = [red, green, blue, ...patternBytes];
                    }
                    break;
                case "2":
                    tmpMotorDriver.needToSendLed2 = true;
                    // RGBとパターンを組み合わせたパケットを作成
                    if (this.driverVersion >= 300) {
                        tmpMotorDriver.packetLed2 = [red, green, blue, ...patternBytes, 0];
                    } else {
                        tmpMotorDriver.packetLed2 = [red, green, blue, ...patternBytes];
                    }
                    break;
            }
            done();
        });
    }
        
    ledRandom(args) {
        lock.acquire('key', (done) => {
            const module = args.MODULE;
            const pin = args.PIN;
            const pattern = args.PATTERN;
            let tmpMotorDriver;
            switch(module) {
                case 'A':
                    tmpMotorDriver = this.connectedDevices[0].driver;
                    break;
                case 'B':
                    tmpMotorDriver = this.connectedDevices[1].driver;
                    break;
                case 'C':
                    tmpMotorDriver = this.connectedDevices[2].driver;
                    break;
                case 'D':
                    tmpMotorDriver = this.connectedDevices[3].driver;
                    break;
            }
            switch (pin) {
                case "1":
                    tmpMotorDriver.needToSendLed1 = true;
                    // パターンをバイト配列に変換
                    let patternBytes1 = [0x00, 0x00, 0x00, 0x00];
                    for (let i = 0; i < pattern.length; i++) {
                        const byteIndex = Math.floor(i / 8);
                        const bitIndex = i % 8;
                        if (pattern[i] === '1') {
                            patternBytes1[byteIndex] |= (1 << bitIndex);
                        }
                    }
    
                    // RGBとパターンを組み合わせたパケットを作成
                    let rgb1 = [255, 255, 255];
                    tmpMotorDriver.packetLed1 = new Int8Array([...rgb1, ...patternBytes1, 0xFF]);
                    break;
                case "2": 
                    tmpMotorDriver.needToSendLed2 = true;
                    // パターンをバイト配列に変換
                    let patternBytes2 = [0x00, 0x00, 0x00, 0x00];
                    for (let i = 0; i < pattern.length; i++) {
                        const byteIndex = Math.floor(i / 8);
                        const bitIndex = i % 8;
                        if (pattern[i] === '1') {
                            patternBytes2[byteIndex] |= (1 << bitIndex);
                        }
                    }
    
                    // RGBとパターンを組み合わせたパケットを作成
                    let rgb2 = [255, 255, 255];
                    tmpMotorDriver.packetLed2 = new Int8Array([...rgb2, ...patternBytes2, 0xFF]);
                    break;
            }
            done();
        });
    }
    
    async sendLEDPacket(device, driver, pin, packet) {
        try {
            if (pin == 1 && driver.needToSendLed1) {
                console.log('sendLEDPacket', pin, " ", driver.needToSendLed1, " ", packet);
                await driver.led1Characteristic.writeValue(new Uint8Array(packet));
                console.log('LED packet1 sent:', packet);
                driver.needToSendLed1 = false;
            } else if (pin == 2 && driver.needToSendLed2) {
                console.log('sendLEDPacket', pin, " ", driver.needToSendLed2, " ", packet);
                await driver.led2Characteristic.writeValue(new Uint8Array(packet));
                console.log('LED packet2 sent:', packet);
                driver.needToSendLed2 = false;
            }
        } catch (error) {
            console.error('Failed to send LED packet:', error);
            if (pin == 1) {
                driver.needToSendLed1 = true;
            } else if (pin == 2) {
                driver.needToSendLed2 = true;
            }
        }
    }

    ledMatrix(args) {
        lock.acquire('key', async (done) => {
            const module = args.MODULE;
            const pin = args.PIN;
            let red = Cast.toNumber(args.RED);
            let green = Cast.toNumber(args.GREEN);
            let blue = Cast.toNumber(args.BLUE);
            const matrix = args.MATRIX;
            let tmpMotorDriver;

            // バージョンが300以上の場合、red, green, blueを0-100の範囲に制限
            if (this.driverVersion >= 300) {
                red = Math.max(0, Math.min(100, red));  // 0-100の範囲に収める
                green = Math.max(0, Math.min(100, green));  // 0-100の範囲に収める
                blue = Math.max(0, Math.min(100, blue));  // 0-100の範囲に収める
            } else {
                // バージョンが300未満の場合、0-255の範囲に収める
                red = Math.max(0, Math.min(255, red));  // 0-255の範囲に収める
                green = Math.max(0, Math.min(255, green));  // 0-255の範囲に収める
                blue = Math.max(0, Math.min(255, blue));  // 0-255の範囲に収める
            }
            
            switch(module) {
                case 'A':
                    tmpMotorDriver = this.connectedDevices[0].driver;
                    break;
                case 'B':
                    tmpMotorDriver = this.connectedDevices[1].driver;
                    break;
                case 'C':
                    tmpMotorDriver = this.connectedDevices[2].driver;
                    break;
                case 'D':
                    tmpMotorDriver = this.connectedDevices[3].driver;
                    break;
            }

            switch (pin) {
                case "1":
                    // MATRIXをバイト配列に変換
                    let patternBytes = [0x00, 0x00, 0x00, 0x00];
                    for (let i = 0; i < matrix.length; i++) {
                        const byteIndex = Math.floor(i / 8);
                        const bitIndex = i % 8;

                        // 偶数行を反転
                        const row = Math.floor(i / 5);
                        const column = i % 5;
                        if (row % 2 === 1) {
                            // 偶数行（0-indexedなので、1,3,...）
                            const reversedColumn = 4 - column;
                            if (matrix[row * 5 + reversedColumn] === '1') {
                                patternBytes[byteIndex] |= (1 << bitIndex);
                            }
                        } else {
                            // 奇数行
                            if (matrix[i] === '1') {
                                patternBytes[byteIndex] |= (1 << bitIndex);
                            }
                        }
                    }

                    // RGBとパターンを組み合わせたパケットを作成
                    tmpMotorDriver.needToSendLed1 = true;
                    if (this.driverVersion >= 300) {
                        tmpMotorDriver.packetLed1 = [red, green, blue, ...patternBytes, 0];
                    } else {
                        tmpMotorDriver.packetLed1 = [red, green, blue, ...patternBytes];
                    }
                    break;
                case "2":
                    // MATRIXをバイト配列に変換
                    let patternBytes2 = [0x00, 0x00, 0x00, 0x00];
                    for (let i = 0; i < matrix.length; i++) {
                        const byteIndex = Math.floor(i / 8);
                        const bitIndex = i % 8;

                        // 偶数行を反転
                        const row = Math.floor(i / 5);
                        const column = i % 5;
                        if (row % 2 === 1) {
                            // 偶数行（0-indexedなので、1,3,...）
                            const reversedColumn = 4 - column;
                            if (matrix[row * 5 + reversedColumn] === '1') {
                                patternBytes2[byteIndex] |= (1 << bitIndex);
                            }
                        } else {
                            // 奇数行
                            if (matrix[i] === '1') {
                                patternBytes2[byteIndex] |= (1 << bitIndex);
                            }
                        }
                    }

                    // RGBとパターンを組み合わせたパケットを作成
                    tmpMotorDriver.needToSendLed2 = true;
                    if (this.driverVersion >= 300) {
                        tmpMotorDriver.packetLed2 = [red, green, blue, ...patternBytes2, 0];
                    } else {
                        tmpMotorDriver.packetLed2 = [red, green, blue, ...patternBytes2];
                    }
                    break;
            }
            done();
        });

    }
    
    //-------------------------------------------------------------------------
    // ジョイスティック変化検知（"when"ブロック用）
    whenJoystickValueChanged(args) {
        // Xの変化有無チェック
        const changedX = (this.joystickX !== this.joystickX_before);
        // Yの変化有無チェック
        const changedY = (this.joystickY !== this.joystickY_before);
    
        // 「ANY」「X」「Y」それぞれに応じて真偽値を返す
        switch(args.AXIS) {
            case 'ANY':
                return changedX || changedY;
            case 'X':
                return changedX;
            case 'Y':
                return changedY;
        }
        // 万一ここにきたらfalse
        return false;
    }

    async sendDataBle() {
        await lock.acquire('key', async () => {
            // console.log("sendDataBle start");
            for (let i = 0; i < this.connectedDevices.length; i++) {
                const device = this.connectedDevices[i];
                if (!device) {
                    continue; // 欠番の場合はスキップ
                }
                const driver = device.driver;
                if (!device.server) {
                    console.error('デバイスに接続されていません。');
                    continue;
                }
                if (driver.needToSend) {
                    // console.log(`send driver : ${driver.name}, needToSend ${driver.needToSend}, needled ${driver.needToSendLed1}, ${driver.needToSendLed2}`);
                    try {
                        // console.log("sendValue: ", driver.sendValue);
                        const bytes = createMessagePackPacket(driver.sendValue);
                        await driver.motorCharacteristic.writeValue(bytes);
                        driver.needToSend = false;
                        console.log("送信しました needToSend flag false");
                    } catch (error) {
                        console.error(`データ送信に失敗しました: ${error}`);
                    }
                }
                await this.sendLEDPacket(device, driver, 1, driver.packetLed1);
                await this.sendLEDPacket(device, driver, 2, driver.packetLed2);
            }

            // 最後の送信から間が空いたら、静止してるとみなして値をセット
            const currentTime = Date.now();
            if (currentTime - this.joystickLastUpdateTime > this.joystickUpdateInterval) {
                // console.log("reset before value:");
                this.joystickX_before = this.joystickX;
                this.joystickY_before = this.joystickY;
                this.sliderValue_before = this.sliderValue;
            }
        });
    }        
    
    static bytesToString(bytes) {
        return new TextDecoder('utf-8').decode(new Uint8Array(bytes));
      }

    static parseCommaSeparatedNumbers(dataView) {
        // DataViewから文字列を取得
        const str = new TextDecoder('utf-8').decode(new Uint8Array(dataView.buffer));
        
        // カンマで分割して数値の配列に変換
        const numbers = str.split(',').map(numStr => parseInt(numStr, 10));
      
        return numbers;
    }
      
    whenPt2ButtonPressed(args) {
        if (args.BTN === 'A') {
            if (!this.buttonA_pressed_before && this.buttonA) {
                return true;
            } 
            this.buttonA_pressed_before = this.buttonA;
        } else if (args.BTN === 'B') {
            if (!this.buttonB_pressed_before && this.buttonB) {
                return true;
            } 
            this.buttonB_pressed_before = this.buttonB;
        } else if (args.BTN === 'X') {
            if (!this.buttonX_pressed_before && this.buttonX) {
                return true;
            } 
            this.buttonX_pressed_before = this.buttonX;
        } else if (args.BTN === 'Y') {
            if (!this.buttonY_pressed_before && this.buttonY) {
                return true;
            } 
            this.buttonY_pressed_before = this.buttonY;
        } else if (args.BTN === 'J') {
            if (!this.buttonJ_pressed_before && this.buttonJ) {
                return true;
            } 
            this.buttonJ_pressed_before = this.buttonJ;
        }
        return false;
    }

    whenPt2ButtonReleased(args) {
        if (args.BTN === 'A') {
            if (!this.buttonA_released_before && !this.buttonA) {
                return true;
            } 
            this.buttonA_released_before = !this.buttonA;
        } else if (args.BTN === 'B') {
            if (!this.buttonB_released_before && !this.buttonB) {
                return true;
            } 
            this.buttonB_released_before = !this.buttonB;
        } else if (args.BTN === 'X') {
            if (!this.buttonX_released_before && !this.buttonX) {
                return true;
            } 
            this.buttonX_released_before = !this.buttonX;
        } else if (args.BTN === 'Y') {
            if (!this.buttonY_released_before && !this.buttonY) {
                return true;
            } 
            this.buttonY_released_before = !this.buttonY;
        } else if (args.BTN === 'J') {
            if (!this.buttonJ_released_before && !this.buttonJ) {
                return true;
            } 
            this.buttonJ_released_before = !this.buttonJ;
        }
        return false;
    }

    whenSliderValueChanged() {
        console.log("whenSliderValueChanged");
        if (this.beforeWhenSliderValueChanged) {
            this.beforeWhenSliderValueChanged = false;
            return false;
        }

        if (this.sliderValue != this.sliderValue_before) {
            this.beforeWhenSliderValueChanged = true;
            return true;    
        }
        this.beforeWhenSliderValueChanged = false;
        return false;
    }

    getJoystickX () {
        return this.joystickX;
    }

    getJoystickY () {
        return this.joystickY;
    }

    getSliderValue () {
        return this.sliderValue;
    }

    getButtonA () {
        return this.buttonA;
    }

    getButtonB () {
        return this.buttonB;
    }

    getButtonJ () {
        return this.buttonJ;
    }
    getDriverA () {
        if (this.connectedDevices.length>0 && this.connectedDevices[0] != null) {
            console.log(`DriverA Name: ${this.connectedDevices[0].name}`); // デバッグ用
            return this.connectedDevices[0].name;
        } else {
            return "none";
        }
    }
    getDriverB () {
        if (this.connectedDevices.length>1 && this.connectedDevices[1] != null) {
            return this.connectedDevices[1].name;
        } else {
            return "none";
        }
    }
    getDriverC () {
        if (this.connectedDevices.length>2 && this.connectedDevices[2] != null) {
            return this.connectedDevices[2].name;
        } else {
            return "none";
        }
    }
    getDriverD () {
        if (this.connectedDevices.length>3 && this.connectedDevices[3] != null) {
            return this.connectedDevices[3].name;
        } else {
            return "none";
        }
    }

    setButtonA(valueA) {
        if (valueA) {
            this.buttonA = true;
        } else {
            this.buttonA = false;
        }
    }
    setButtonB(valueB) {
        if (valueB) {
            this.buttonB = true;
        } else {
            this.buttonB = false;
        }
    }
    setButtonJ(valueJ) {
        if (valueJ) {
            this.buttonJ = true;
        } else {
            this.buttonJ = false;
        }
    }
    setButtonX(valueX) {
        if (valueX) {
            this.buttonX = true;
        } else {
            this.buttonX = false;
        }
    }
    setButtonY(valueY) {
        if (valueY) {
            this.buttonY = true;
        } else {
            this.buttonY = false;
        }
    }

    writeProgram() {
        const vm = this.runtime;
        var json = this.runtime.toJSON();

        console.log(`projectData : ${json}`);
    }
}



function collectMetadata(vm, projectName = '', locale = '') {
    // TODO move most or all of this into a collectMetadata() method on the VM/Runtime
    const metadata = {
        projectName: projectName,
        language: locale,
        spriteCount: 0,
        blocksCount: 0,
        costumesCount: 0,
        listsCount: 0,
        scriptCount: 0,
        soundsCount: 0,
        variablesCount: 0
    };

    for (const target of vm.targets) {
        ++metadata.spriteCount;
        metadata.blocksCount += Object.keys(target.sprite.blocks._blocks).length;
        metadata.costumesCount += target.sprite.costumes_.length;
        metadata.scriptCount += target.sprite.blocks._scripts.length;
        metadata.soundsCount += target.sprite.sounds.length;
        for (const variableName in target.variables) {
            const variable = target.variables[variableName];
            if (variable.type === 'list') {
                ++metadata.listsCount;
            } else {
                ++metadata.variablesCount;
            }
        }
    }
    return metadata;
};

function getScriptsFromBlocks(blocks) {
    const scripts = [];
    for (const blockId in blocks) {
        const block = blocks[blockId];
        // トップレベルのブロック（他のブロックに接続されていないブロック）を探す
        if (!block.parent) {
            const script = [];
            let currentBlockId = blockId;
            // 連続するブロックをたどってスクリプトを再構築
            while (currentBlockId) {
                const currentBlock = blocks[currentBlockId];
                script.push(currentBlock); // ブロックをスクリプトに追加
                currentBlockId = currentBlock.next; // 次のブロックに移動
            }
            scripts.push(script); // 完成したスクリプトを追加
        }
    }
    return scripts;
}

function createMessagePackPacket(sendValue) {
    const json = {
      v: sendValue,
      c: 255,
    };
  
    const bytes = encode(json);
    return bytes;
}

// バイト配列を16進数の文字列に変換する関数
function bytesToHex(bytes) {
    return Array.from(bytes)
      .map(b => b.toString(16).padStart(2, "0"))
      .join("");
  }
  
module.exports = Scratch3NewBlocks;